export default __webpack_public_path__ + "static/media/ic_certificate.26e691e0.png";